import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

export const Forbidden = () => {
  return (
    <div
      data-testid={ADMIN.forbidden}
      className="flex min-h-screen flex-col items-center justify-center bg-[var(--tc-surface)] px-5 text-center"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
        <ShieldAlert size={26} />
      </span>
      <h1 className="mt-4 text-lg font-semibold text-[var(--tc-text)]">No tenés permiso para ver esta página</h1>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-[var(--tc-text-secondary)]">
        Tu cuenta no tiene acceso al panel interno de LOCCITEC.
      </p>
      <Link
        data-testid={ADMIN.forbiddenBackLink}
        to="/"
        className="mt-6 inline-flex items-center gap-2 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--tc-accent-hover)]"
      >
        Volver al inicio
      </Link>
    </div>
  );
};
